<template>
  <el-row>
    <el-col :span="24">
      <el-card>
        <div slot="header" class="clearfix flex justify-between">
          <span>{{ $t('viewMenuGroupInfo.title') }}</span>
          <div style="float: right;">
            <el-button 
              v-if="viewMenuGroupInfo.index !== 2" 
              type="primary" 
              size="small"
              style="margin-right:10px;"
              @click="openSelectMenuGroupModel">
              <i class="el-icon-search"></i>
              <span>{{ $t('viewMenuGroupInfo.selectMenuGroup') }}</span>
            </el-button>
            <el-button 
              v-if="viewMenuGroupInfo.index !== 2" 
              type="primary" 
              size="small"
              @click="openAddMenuGroupModel">
              <i class="el-icon-plus"></i>
              <span>{{ $t('viewMenuGroupInfo.addMenuGroup') }}</span>
            </el-button>
          </div>
        </div>
        <div class="content">
          <el-row>
            <el-col :span="8">
              <div class="form-item">
                <label class="el-form-item__label">
                  {{ $t('viewMenuGroupInfo.groupName') }}：
                </label>
                <div class="el-form-item__content">
                  {{ viewMenuGroupInfo.name }}
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="form-item">
                <label class="el-form-item__label">icon：</label>
                <div class="el-form-item__content">
                  {{ viewMenuGroupInfo.icon }}
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="form-item">
                <label class="el-form-item__label">
                  {{ $t('viewMenuGroupInfo.label') }}：
                </label>
                <div class="el-form-item__content">
                  {{ viewMenuGroupInfo.label }}
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <div class="form-item">
                <label class="el-form-item__label">
                  {{ $t('viewMenuGroupInfo.seq') }}：
                </label>
                <div class="el-form-item__content">
                  {{ viewMenuGroupInfo.seq }}
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="form-item">
                <label class="el-form-item__label">
                  {{ $t('viewMenuGroupInfo.description') }}：
                </label>
                <div class="el-form-item__content">
                  {{ viewMenuGroupInfo.description }}
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-card>
    </el-col>

    <add-menu-group ref="addMenuGroup" @chooseMenuGroup="handleChooseMenuGroup"></add-menu-group>
    <choose-menu-group ref="chooseMenuGroup" @chooseMenuGroup="handleChooseMenuGroup"></choose-menu-group>
  </el-row>
</template>

<script>
import AddMenuGroup from '../addMenuGroup/addMenuGroup'
import ChooseMenuGroup from '../chooseMenuGroup/chooseMenuGroup'

export default {
  name: 'ViewMenuGroupInfo',
  components: {
    AddMenuGroup,
    ChooseMenuGroup
  },
  props: {
    callBackListener: String,
    callBackFunction: String
  },
  data() {
    return {
      viewMenuGroupInfo: {
        index: 0,
        flowComponent: 'viewMenuGroupInfo',
        name: '',
        icon: '',
        label: '',
        seq: '',
        description: '',
        gId: ''
      }
    }
  },
  methods: {
    openSelectMenuGroupModel() {
      this.$refs.chooseMenuGroup.open()
    },
    openAddMenuGroupModel() {
      this.$refs.addMenuGroup.open()
    },
    handleChooseMenuGroup(menuGroup) {
      Object.assign(this.viewMenuGroupInfo, menuGroup)
      this.$emit(this.callBackFunction, this.viewMenuGroupInfo)
    },
    onIndex(index) {
      this.viewMenuGroupInfo.index = index
    }
  }
}
</script>

<style scoped>
.el-row, .el-col {
  width: 100%;
}
.form-item {
  margin-bottom: 18px;
}
.el-form-item__label {
  float: left;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  padding: 0 12px 0 0;
  box-sizing: border-box;
}
.el-form-item__content {
  line-height: 40px;
  position: relative;
  font-size: 14px;
}
</style>